import { FC, PropsWithChildren } from 'react';
import { Badge, Box, Button, HStack } from '@chakra-ui/react';
import {
  ProjectStatus,
  CompanyStatus,
  SubscriptionPlanName,
  WorkflowStatus,
} from '../models';

type ColorSchema =
  | CompanyStatus
  | SubscriptionPlanName
  | ProjectStatus
  | WorkflowStatus;

export const RoundedBadge: FC<
  PropsWithChildren<{
    colorSchema: ColorSchema;
    withCloseButton?: boolean;
    textMapper?: (text: ColorSchema) => string;
    onClose?: (closedData?: string) => void;
  }>
> = ({ children, colorSchema, withCloseButton, textMapper, onClose }) => {
  let bg = 'custom_green.4';
  let borderColor = 'custom_green.3';
  let color = 'custom_green.1';

  if ([CompanyStatus.ACTIVE].includes(colorSchema)) {
    color = 'custom_green.1';
    borderColor = 'custom_green.3';
    bg = 'custom_green.4';
  } else if (
    [CompanyStatus.PENDING, ProjectStatus.PENDING_ACTIVATION].includes(
      colorSchema
    )
  ) {
    color = 'pending.1';
    borderColor = 'pending.2';
    bg = 'pending.3';
  } else if (
    [CompanyStatus.INACTIVE, ProjectStatus.CANCELLED].includes(colorSchema)
  ) {
    color = 'inactive.1';
    borderColor = 'inactive.2';
    bg = 'inactive.3';
  } else if (colorSchema === SubscriptionPlanName.Golden) {
    color = 'inactive.1';
    borderColor = 'custom_orange.3';
    bg = 'custom_orange.4';
  } else if (colorSchema === SubscriptionPlanName.Platinum) {
    color = 'custom_blue.2';
    borderColor = 'custom_blue.3';
    bg = 'custom_blue.4';
  } else if (colorSchema === SubscriptionPlanName.Starter) {
    color = 'shiny_blue.1';
    borderColor = 'shiny_blue.2';
    bg = 'shiny_blue.3';
  }

  return (
    <Badge
      variant="subtle"
      borderRadius="2xl"
      color={color}
      bg={bg}
      border="1px"
      borderColor={borderColor}
      textTransform="capitalize"
      px="3"
      py="1"
    >
      <HStack>
        <Box>{textMapper ? textMapper(children?.toString()) : children}</Box>
        {withCloseButton && (
          <Button
            color={color}
            bg="none"
            _hover={{ bg: 'none' }}
            h="fit-content"
            w="fit-content"
            minW="fit-content"
            fontWeight="normal"
            fontSize="sm"
            p="0"
            outline="none"
            lineHeight="none"
            onClick={() => {
              onClose && onClose(colorSchema);
            }}
          >
            x
          </Button>
        )}
      </HStack>
    </Badge>
  );
};
